import { MemberApi } from "@/services/Api";
import { EmailValidatorResult } from "@/models/AccountRegister";

export class Validator {
  static emailValidate = async (email: string): Promise<EmailValidatorResult> => {
    try {
      if (Validator.isValidEmailAddress(email)) {
        const result = await MemberApi.validateEmail(email);
        return result;
      } else {
        return EmailValidatorResult.InvalidEmailFormat;
      }
    } catch (e) {
      return EmailValidatorResult.InvalidEmailFormat;
    }
  };

  static zipCodeRules = () => {
    const lang = (document.querySelector("html") as HTMLHtmlElement).getAttribute("lang") as string;
    let zipCodeRules = /^[0-9]{4,5}$/;
    if (lang == "sv") {
      zipCodeRules = /^[0-9]{5}$/;
    }
    return zipCodeRules;
  };

  static isValidEmailAddress(email: string): boolean {
    // Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
    const emailRegExp =
      /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return emailRegExp.test(email);
  }
}
